import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../../../constants/path';
import { STATIC_ROOT } from '../../../constants';
import { MEMBRE_VERSION_MENU_MOBILE_SLIDE } from '../../../services/header/constants';

import SvgComponent from '../../SvgComponent';
import ButtonComponent from '../../button/ButtonComponent';
import LinkButtonComponent from '../../button/LinkButtonComponent';
import LoginFormComponent from '../../authentication/login/LoginFormComponent';
import LogoutButtonComponent from '../../authentication/logout/LogoutButtonComponent';

class MobileMemberNavComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showLoginForm: false
        };
    }

    showLoginFormOnClick = () => {
        this.setState({
            showLoginForm: !this.state.showLoginForm
        });
    };

    renderConditionnalAuthenticatedNav = () => {
        const { i18n, isAuthenticated } = this.props;

        if (isAuthenticated) {
            return (
                <div className="menu-membre-mobile-connexion menu-membre-mobile-coinscr">
                    <p className="txtcenter">
                        <LinkButtonComponent
                            color="main"
                            to={PATH.ACCOUNT_JACKPOT_PATH}
                            name="mobileNavAcountButton-toMyJackpot"
                            text={i18n.SEE_MY_ACCOUNT}
                            title={i18n.SEE_MY_ACCOUNT}
                        />
                    </p>
                    <p className="txtcenter">
                        <LogoutButtonComponent text={i18n.LOG_OUT} isButton />
                    </p>
                </div>
            );
        }
    };

    renderConditionnalNotAuthenticatedNav = () => {
        const { i18n, isAuthenticated } = this.props;

        if (!isAuthenticated && !this.state.showLoginForm) {
            return (
                <div>
                    <div className="menu-membre-mobile-connexion menu-membre-mobile-coinscr">
                        <p className="txtcenter">
                            <span className="bold">{i18n.MOBILE_MENU_LOGIN_TITLE}</span>
                            <br />
                            <ButtonComponent
                                text={i18n.LOGIN_BUTTON}
                                color="main"
                                cssClass="btn-menu-mobile"
                                onClick={this.showLoginFormOnClick}
                            />
                        </p>
                    </div>
                    <div className="menu-membre-mobile-inscription menu-membre-mobile-coinscr">
                        <p className="txtcenter">
                            <span className="bold">{i18n.MOBILE_MENU_REGISTER_TITLE}</span>
                            <br />
                            <LinkButtonComponent
                                to={PATH.REGISTER_PATH}
                                title={i18n.REGISTER_BUTTON}
                                text={i18n.REGISTER_BUTTON}
                                color="main"
                                cssClass="btn-menu-mobile"
                            />
                        </p>
                    </div>
                </div>
            );
        }
    };

    renderConditionnalLoginForm = () => {
        const { i18n, isAuthenticated, location } = this.props;

        if (!isAuthenticated && this.state.showLoginForm) {
            return (
                <div className="conteneur-mobile form-menu-mobile">
                    <h3>{i18n.LOG_IN}</h3>
                    <LoginFormComponent currentPath={location.pathname} />
                    <br />
                    <ButtonComponent
                        text={i18n.RETURN_BUTTON}
                        color="main"
                        onClick={this.showLoginFormOnClick}
                    />
                </div>
            );
        }
    };

    render() {
        const { i18n, stateOpenMenuMobileSlide, versionOpenMenuMobileSlide } = this.props;
        return (
            <div
                className={`menu-membre-mobile menu-mobile-slide show-mobonly ${
                    stateOpenMenuMobileSlide &&
                    versionOpenMenuMobileSlide === MEMBRE_VERSION_MENU_MOBILE_SLIDE
                        ? 'open'
                        : ''
                }`}
                id="connexion-inscription-mobile">
                <div className="menu-mobile-slide-conteneur">
                    <div className="menu-mobile-slide-titre bold flex-container-h flex-center-alt">
                        <div className="menu-membre-ico">
                            <SvgComponent src={`${STATIC_ROOT}/avatar.svg`} />
                        </div>
                        {i18n.CUSTOMER_AREA}
                    </div>
                    {this.renderConditionnalAuthenticatedNav()}
                    {this.renderConditionnalNotAuthenticatedNav()}
                    {this.renderConditionnalLoginForm()}
                </div>
            </div>
        );
    }
}

MobileMemberNavComponent.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    stateOpenMenuMobileSlide: PropTypes.bool.isRequired,
    versionOpenMenuMobileSlide: PropTypes.string.isRequired,
    i18n: PropTypes.object.isRequired
};

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {
        i18n: state.i18n.feature.header.MEMBER_NAV,
        location: state.routing.location
    };
}

export default connect(mapStateToProps)(MobileMemberNavComponent);



// WEBPACK FOOTER //
// ./src/components/header/membernav/MobileMemberNavComponent.js